<template>
	<img class="app-img lozad">
</template>

<script>
import lozad from 'lozad'

export default {
	mounted() {
		const observer = lozad()
		observer.observe()
	},
}
</script>

<style>
.app-img {
	max-width: 100% !important;
}
</style>
